import { List } from 'immutable';
import createCachedSelector from 're-reselect';

import { orderByGlobalPriority } from 'app/lib/grid';

export default (
  matches,
  getStagesFromTournamentsSelector,
) => {
  const orderMatchesByStartTime = () => {
    return orderByGlobalPriority;
  };

  /**
   * @private
   *
   * Collect all tournament matches.
   *
   * @param {Immutable.Map<number, MatchEntity>} matchesById
   * @param {function} orderingFunction
   * @param {Immutable.Map<TournamentStage>} tournamentStages
   * @return {Immutable.List<number>}
   */
  function collectTournamentMatchIds(matchesById, orderingFunction, tournamentStages) {
    if (!tournamentStages) {
      return List();
    }

    const matchIds = tournamentStages.reduce((list, tournamentStage) => {
      return tournamentStage ? list.concat(tournamentStage.matchIds) : list;
    }, List());

    return orderingFunction(matchesById, matchIds);
  }

  /**
   * Create "tournament's matchIds" selector for an instance of `<TournamentTable />` HOC.
   *
   * @return {function(state:object):Immutable.List<number>}
   */
  return createCachedSelector(
    matches,
    orderMatchesByStartTime,
    getStagesFromTournamentsSelector,
    /**
     * @param {Immutable.Map<number, MatchEntity>} matchesById
     * @param {function} orderingFunction
     * @param {Immutable.Map<TournamentStage>} tournamentStages
     */
    (matchesById, orderingFunction, tournamentStages) => {
      return collectTournamentMatchIds(matchesById, orderingFunction, tournamentStages);
    },
  )((state, tournamentId) => tournamentId);
};
